import { createBrowserHistory as history} from 'history';

export default history();


// WEBPACK FOOTER //
// ./src/component/history/History.js